import { teacherDisplayName } from './teacherTitle.ts';
import { stampedParticipantLabel } from './threadLabels.ts';

export interface CommunityLabelThread {
  communityOfferingId?: string;
  participantLabels?: Record<string, string>;
}

export interface MessageSenderIdentity {
  uid: string;
  displayName?: string | null;
  email?: string | null;
  teacherTitle?: 'ms' | 'coach';
}

/** Keep parent contact details out of community message notifications. */
export function messageNotificationSenderName(
  thread: CommunityLabelThread,
  sender: MessageSenderIdentity
): string {
  if (thread.communityOfferingId) {
    return stampedParticipantLabel(thread.participantLabels, sender.uid) ?? 'Parent or guardian';
  }
  // email-ok: a presence test for whether the account has anything on it.
  // teacherDisplayName is what renders, and it never returns an address.
  if (!sender.displayName?.trim() && !sender.email?.trim()) return 'Someone';
  return teacherDisplayName(sender);
}

/** Parent community alerts stay inside the Hub's active-account boundary. */
export function communityMessageNotifyOptions(threadId: string, senderName: string) {
  return {
    server: false as const,
    communityThread: { id: threadId, senderName },
  };
}
